export enum OrganizationType {
  NYCBS = "HhwIHO4npKhrxyylkC33",
  MBM = "3GKbZtgpPru1vJGCkxwR",
  MBP = "3GKbZtgpPru1vJGCkxwR",
  CHC = "4BlQ4SsqAVTDgFKApKZr",
  ASTERA = "tPvNbDprUnrXIJlDXyxs",
  DEMO_FACILITY = "57zhkss5CaF9dz90wcpv",
  NYCBS_DRUG_CONFIG = "hwKXreFwPrMpA8Pad7Mr",
  NYCBS_PHARMA = "hwKXreFwPrMpA8Pad7Mr",
  UCBC = "W14MolgUu7OYvX4CFQJn",
  NYCBS_HYD = "Y15ePfa5kC35QiChxXil",
  GENESIS_CARE = "sfmlrFGXYg3aBMdTs4od",
  ASTERA_RADIOLOGY = "rf5w1cNTGVfH9ZAJoLCF",
  /** Sunstate Urology — Firebase organization document ID. */
  SUNSTATE_UROLOGY = "jL5P8oAYMioqeLjR0wbz",
  NYCBS_STAT = "2gsIT00cmhoKc7fYwhnX",
}

/**
 * Orgs that follow the appointment/estimate-based "urology exception" flow
 * instead of the standard medication PA flow. Add an org here to enable the
 * full Sunstate-style behavior package (estimate-value columns/filters,
 * Appointment Type / Procedures labels, shared worklists, no visit data, etc.).
 */
export const exceptionFlowForUrologyOrgs: readonly OrganizationType[] = [
  OrganizationType.SUNSTATE_UROLOGY,
];

/**
 * Returns true when the org follows the urology exception flow.
 *
 * @param orgId - Firebase organization document ID (nullable)
 * @returns True when orgId is in exceptionFlowForUrologyOrgs
 */
export const isExceptionFlowForUrologyOrg = (orgId?: string | null): boolean =>
  exceptionFlowForUrologyOrgs.includes(orgId as OrganizationType);

/**
 * Facilities exempted from the "Date From" validation on CPT/J-code rows.
 *
 * For these organizations the start-date cell should never surface
 * validation error even when the auth is on file or by RISA — typically
 * because their workflow does not require a start date that precedes the
 * order's date of service.
 */
export const facilitiesForExceptionDateFromValidation = [
  OrganizationType.ASTERA_RADIOLOGY,
  OrganizationType.SUNSTATE_UROLOGY,
];
